import classNames from 'classnames';
import { StatDisplay, StatDisplayProps } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { PushPinIcon, SatelliteIcon } from 'app/agriculture/icons';
import { successColourMain } from 'app/agriculture/material';
interface FixedLocationProps extends StatDisplayProps {
    usingLocationOverride: boolean;
}

export function FixedLocationStat({
    usingLocationOverride,
    className,
    ...statDisplayProps
}: FixedLocationProps) {
    const Icon = usingLocationOverride ? PushPinIcon : SatelliteIcon;
    return (
        <StatDisplay
            {...statDisplayProps}
            className={classNames(className, 'FixedLocation')}
            value={usingLocationOverride ? 'Fixed location' : 'Device GPS'}
            Icon={(props) => <Icon {...props} color={successColourMain} />}
        />
    );
}
